module.exports = __webpack_public_path__ + "img/montevideo.87d0ce63.jpg";